import { useEffect, useState } from '@wordpress/element';
import { API } from '../API';

import Form from './Form';
import TableONGs from './TableONGs';
import Navigation from './Navigation';

function ONGs() {

  const ONGsAPI = new API({
    hasLogo: false
  });
  
  const defaultArgs = {
    posts_per_page: 20,
  }

  const [allONGs, setAllONGs] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  

  const goToPage = (pageNumber) => {
    setPage(pageNumber);
    const query = { ...defaultArgs, page: pageNumber };
    ONGsAPI.loadContent(query).then( response => {
      setAllONGs(response.data);
    });
  }

  const searchQuery = (query) => {
    const searchQuery = { ...defaultArgs, search: query };
    ONGsAPI.loadContent(searchQuery).then( response => {
      setAllONGs(response.data);
      setTotalPages(response.totalPages);
    });
  }

  useEffect(() => {
    ONGsAPI.loadContent(defaultArgs).then( response => {
      setAllONGs(response.data);
      setTotalPages(response.totalPages);
    });
  }, []);
    

  return (
    <>
      <Form searchQuery={searchQuery} />
      { allONGs.length > 0 ? (
        <>
          <TableONGs ONGs={allONGs} />
          <Navigation page={page} totalPages={totalPages} goToPage={goToPage} />
        </>
      ) : (
        <p>Not found</p>
      )}
    </>
  );
}

export default ONGs;